module.exports = __webpack_public_path__ + "fonts/a0606c5.ttf";